export default __webpack_public_path__ + "static/media/newmessagealert.a673b70c.wav";